import { render, staticRenderFns } from "./ParentStudentOverview.vue?vue&type=template&id=7d3b8028&scoped=true"
import script from "./ParentStudentOverview.vue?vue&type=script&lang=js"
export * from "./ParentStudentOverview.vue?vue&type=script&lang=js"
import style0 from "./ParentStudentOverview.vue?vue&type=style&index=0&id=7d3b8028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3b8028",
  null
  
)

export default component.exports